import React from 'react'
import { Heading } from 'atoms/Texts'
import MocaLogo from 'atoms/Logos'
import { HeaderContainer } from './styles'

const AuthHeader = ({ size, title }) => (
  <HeaderContainer>
    <MocaLogo size={'80'} mt={'47px'} mb={'24px'} />
    <Heading altFont={true} size={size ? size : 'm'}>
      {title}
    </Heading>
  </HeaderContainer>
)

export default AuthHeader
